//ラッシングデータ =============================

var sb25_lashing_step1 = [
  {
    hx: "50mm",
    text: "業務用なら50mm幅がオススメです。破断荷重も高く、しっかり固縛できます。",
    img: null,
    tag: '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/img_selecthook11.png" alt="選べるフック 最大11種">',
    tag_color:
      '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/img_selectcolr13.png" alt="選べるカラー 最大13種">',
    chips:
      '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_01blue.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_02black.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_03white.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_04red.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_05yellow.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_06gray.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_07od.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_08bi_blgr.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_09bi_blwh.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_10bi_blod.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_11bi_whor.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_12bi_blye.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_14tainetsu.png">',
  },
  {
    hx: "35mm",
    text: "細く軽いため、扱いやすいベルトです。軽量な荷物を扱う現場に適しています。",
    img: null,
    tag: '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/img_selecthook4.png" alt="選べるフック 最大4種">',
    tag_color:
      '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/img_selectcolr3.png" alt="選べるカラー 最大3種">',
    chips:
      '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_03white.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_15red_35mm.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_13org.png">',
  },
  {
    hx: "25mm",
    text: "非常時に便利な小型ベルトです。省スペースで常備にも困りません。",
    img: null,
    tag: '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/img_selecthook4.png" alt="選べるフック 最大4種">',
    tag_color:
      '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/img_selectcolr2.png" alt="選べるカラー 最大2種">',
    chips:
      '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_03white.png"><img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/chip_16tainetsu_25mm.png">',
  },
];

var sb25_lashing_step2 = [
  {
    type: "50mm",
    hook: "r",
    hx: "Rフック",
    text: "トラックレール、<br>ラッシングレール対応",
    img: '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/sb25_sec_lashing_hook_r.png" alt="Rフック の画像">',
  },
  {
    type: "50mm/35mm/25mm",
    hook: "j",
    hx: "Jフック",
    text: "D環、ロッカーレール、フレーム、<br>アングル、パイプ等対応",
    img: '<img src="https://www.slingbelt.com/cdn/shop/files/sb25_sec_lashing_hook_j.png" alt="Jフック の画像">',
  },
  {
    type: "50mm",
    hook: "js",
    hx: 'J<span class="sb25_common_brackets">シングル</span>フック',
    text: "D環、ロッカーレール、フレーム、<br>アングル、パイプ等対応",
    img: '<img src="https://www.slingbelt.com/cdn/shop/files/sb25_sec_lashing_hook_j_single.png" alt="Jフック(シングル) の画像">',
  },
  {
    type: "50mm/35mm/25mm",
    hook: "i",
    hx: "Iフック",
    text: "ロープフック対応。<br>別名：ワッカ、アイタイプ。",
    img: '<img src="https://www.slingbelt.com/cdn/shop/files/sb25_sec_lashing_hook_i.png" alt="Iフック の画像">',
  },
  {
    type: "50mm",
    hook: "rj",
    hx: "RJフック",
    text: '<span class="cl_compact">トラックレール・ラッシングレール<br>D環、ロッカーレール、フレーム、<br>アングル、パイプ等対応</span>',
    img: '<img src="https://www.slingbelt.com/cdn/shop/files/sb25_sec_lashing_hook_rj.png" alt="RJフック の画像">',
  },
  {
    type: "50mm/35mm/25mm",
    hook: "ij",
    hx: "IJフック",
    text: '<span class="cl_compact">ロープフック、D環、<br>ロッカーレール、フレーム、<br>アングル、パイプ等対応</span>',
    img: '<img src="https://www.slingbelt.com/cdn/shop/files/sb25_sec_lashing_hook_ij.png" alt="IJフック の画像">',
  },
  {
    type: "50mm",
    hook: "s",
    hx: "スナップフック",
    text: "D環、ロッカーレール、フレーム、<br>アングル、パイプ等対応",
    img: '<img src="https://www.slingbelt.com/cdn/shop/files/sb25_sec_lashing_hook_snap.png" alt="スナップフック の画像">',
  },
  {
    type: "50mm",
    hook: "st",
    hx: 'スナップ<span class="sb25_common_brackets">ツイスト</span>フック',
    text: "D環、ロッカーレール、フレーム、<br>アングル、パイプ等対応",
    img: '<img src="https://www.slingbelt.com/cdn/shop/files/sb25_sec_lashing_hook_snap_twist.png" alt="スナップ(ツイスト)フック の画像">',
  },
  {
    type: "50mm",
    hook: "f",
    hx: "フラットフック",
    text: "D環、ロッカーレール、フレーム、<br>アングル、パイプ等対応",
    img: '<img src="https://www.slingbelt.com/cdn/shop/files/sb25_sec_lashing_hook_flat.png" alt="ふらっとkフック の画像">',
  },
  {
    type: "50mm",
    hook: "d",
    hx: "デルタリング",
    text: "D環、ロッカーレール、フレーム、<br>アングル、パイプ等対応",
    img: '<img src="https://www.slingbelt.com/cdn/shop/files/sb25_sec_lashing_hook_d.png" alt="デルタリング の画像">',
  },
  {
    type: "50mm/35mm/25mm",
    hook: "e",
    hx: "エンドレス",
    text: "フックがなく全体が輪っかに<br>なったタイプ",
    img: '<img src="https://www.slingbelt.com/cdn/shop/files/sb25_sec_lashing_hook_endless.png" alt="エンドレス の画像">',
  },
  {
    type: "50mm",
    hook: "rtj",
    hx: "積載車用ベルト",
    text: "車両固縛用ラッシングベルト。<br>タイヤの固定に最適です。",
    img: '<img src="https://www.slingbelt.com/cdn/shop/files/sb25_sec_lashing_hook_sekisai.png" alt="積載車用ベルト の画像">',
  },
];

// 自動生成する配列を作成
var sb25_lashing_step3 = [
  {
    type: "50mm",
    color: "blu",
    hx: "ブルー",
    text: "定番のお手頃価格！",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm ブルー の画像">',
    img_url: {
      r: "https://www.slingbelt.com/cdn/shop/files/lashing-rr_blu_01.jpg?width=160",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_blu_01.jpg?width=160",
      js: "https://www.slingbelt.com/cdn/shop/files/lashing-rjs_blu_01.jpg?width=160",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_blu_01.jpg?width=160",
      rj: "https://www.slingbelt.com/cdn/shop/files/lashing-rrj_blu_01.jpg?width=160",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_blu_01.jpg?width=160",
      s: "https://www.slingbelt.com/cdn/shop/files/lashing-rs_blu_01.jpg?width=160",
      st: "https://www.slingbelt.com/cdn/shop/files/lashing-ts_blu_01.jpg?width=160",
      f: "https://www.slingbelt.com/cdn/shop/files/lashing-rf_blu_01.jpg?width=160",
      d: "https://www.slingbelt.com/cdn/shop/files/lashing-rd_blu_01.jpg?width=160",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re_blu_01.jpg?width=160",
      rtj: "https://www.slingbelt.com/cdn/shop/files/lashing-rtj_blu_01.jpg?width=160",
    },
    link_url: {
      r: "https://www.slingbelt.com/products/las50-r-blu",
      j: "https://www.slingbelt.com/products/las50-j-blu",
      js: "https://www.slingbelt.com/products/las50-js-blu",
      i: "https://www.slingbelt.com/products/las50-i-blu",
      rj: "https://www.slingbelt.com/products/las50-rj-blu",
      ij: "https://www.slingbelt.com/products/las50-ij-blu",
      s: "https://www.slingbelt.com/products/las50-s-blu",
      st: "https://www.slingbelt.com/products/las50-st-blu",
      f: "https://www.slingbelt.com/products/las50-f-blu",
      d: "https://www.slingbelt.com/products/las50-d-blu",
      e: "https://www.slingbelt.com/products/las50-e-blu",
      rtj: "https://www.slingbelt.com/products/las50-js-blu-tj",
    },
  },
  {
    type: "50mm",
    color: "blk",
    hx: "ブラック",
    text: "大人気カラー！",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm ブラック の画像">',
    img_url: {
      r: "https://www.slingbelt.com/cdn/shop/files/lashing-rr_blk_01.jpg?width=160",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_blk_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_blk_01.jpg?width=160",
      rj: "https://www.slingbelt.com/cdn/shop/files/lashing-rrj_blk_01.jpg?width=160",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_blk_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "https://www.slingbelt.com/cdn/shop/files/lashing-rd_blk_01.jpg?width=160",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re_blk_01.jpg?width=160",
      rtj: "https://www.slingbelt.com/cdn/shop/files/lashing-rtj_blk_01.jpg?width=160",
    },
    link_url: {
      r: "https://www.slingbelt.com/products/las50-r-blk",
      j: "https://www.slingbelt.com/products/las50-j-blk",
      js: "",
      i: "https://www.slingbelt.com/products/las50-i-blk",
      rj: "https://www.slingbelt.com/products/las50-rj-blk",
      ij: "https://www.slingbelt.com/products/las50-ij-blk",
      s: "",
      st: "",
      f: "",
      d: "https://www.slingbelt.com/products/las50-d-blk",
      e: "https://www.slingbelt.com/products/las50-e-blk",
      rtj: "https://www.slingbelt.com/products/las50-js-blk-tj",
    },
  },
  {
    type: "50mm",
    color: "wht",
    hx: "ホワイト",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm ホワイト の画像">',
    img_url: {
      r: "https://www.slingbelt.com/cdn/shop/files/lashing-rr_wht_01.jpg?width=160",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_wht_01.jpg?width=160",
      js: "https://www.slingbelt.com/cdn/shop/files/lashing-rjs_wht_01.jpg?width=160",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_wht_01.jpg?width=160",
      rj: "https://www.slingbelt.com/cdn/shop/files/lashing-rrj_wht_01.jpg?width=160",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_wht_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "https://www.slingbelt.com/cdn/shop/files/lashing-rd_wht_01.jpg?width=160",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re_wht_00.jpg?width=160",
      rtj: "https://www.slingbelt.com/cdn/shop/files/lashing-rtj_wht_01.jpg?width=160",
    },
    link_url: {
      r: "https://www.slingbelt.com/products/las50-r-wht",
      j: "https://www.slingbelt.com/products/las50-j-wht",
      js: "https://www.slingbelt.com/products/las50-js-wht",
      i: "https://www.slingbelt.com/products/las50-i-wht",
      rj: "https://www.slingbelt.com/products/las50-rj-wht",
      ij: "https://www.slingbelt.com/products/las50-ij-wht",
      s: "",
      st: "",
      f: "",
      d: "https://www.slingbelt.com/products/las50-d-wht",
      e: "https://www.slingbelt.com/products/las50-e-wht",
      rtj: "https://www.slingbelt.com/products/las50-js-wht-tj",
    },
  },
  {
    type: "50mm",
    color: "red",
    hx: "反射レッド",
    text: "暗所での視認性UP！",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm レッド の画像">',
    img_url: {
      r: "https://www.slingbelt.com/cdn/shop/files/lashing-rr_rs_01.jpg?width=160",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_rs_01.jpg?width=160",
      js: "https://www.slingbelt.com/cdn/shop/files/lashing-rjs_rs_01.jpg?width=160",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_rs_01.jpg?width=160",
      rj: "https://www.slingbelt.com/cdn/shop/files/lashing-rrj_rs_01.jpg?width=160",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_rs_01.jpg?width=160",
      s: "https://www.slingbelt.com/cdn/shop/files/lashing-rs_rs_01.jpg?width=160",
      st: "https://www.slingbelt.com/cdn/shop/files/lashing-rs_tw_rs_01.jpg?width=160",
      f: "https://www.slingbelt.com/cdn/shop/files/lashing-rf_rs_01.jpg?width=160",
      d: "https://www.slingbelt.com/cdn/shop/files/lashing-rd_rs_01.jpg?width=160",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re_rs_00.jpg?width=160",
      rtj: "https://www.slingbelt.com/cdn/shop/files/lashing-rtj_rs_01.jpg?width=160",
    },
    link_url: {
      r: "https://www.slingbelt.com/products/las50-r-red-rs",
      j: "https://www.slingbelt.com/products/las50-j-red-rs",
      js: "https://www.slingbelt.com/products/las50-js-red",
      i: "https://www.slingbelt.com/products/las50-i-red-rs",
      rj: "https://www.slingbelt.com/products/las50-rj-red-rs",
      ij: "https://www.slingbelt.com/products/las50-ij-red-rs",
      s: "https://www.slingbelt.com/products/las50-s-red-rs",
      st: "https://www.slingbelt.com/products/las50-st-red-rs",
      f: "https://www.slingbelt.com/products/las50-f-red-rs",
      d: "https://www.slingbelt.com/products/las50-d-red-rs",
      e: "https://www.slingbelt.com/products/las50-e-red-rs",
      rtj: "https://www.slingbelt.com/products/las50-js-red-tj",
    },
  },
  {
    type: "50mm",
    color: "yp",
    hx: '<span class="cl_compact">イエロー[強化タイプ]</span>',
    text: "暗所での視認性UP！",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm イエロー強化タイプ の画像">',
    img_url: {
      r: "",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_yp_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_yp_01.jpg?width=160",
      rj: "",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_yp_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re_yp_01.jpg?width=160",
      rtj: "",
    },
    link_url: {
      r: "",
      j: "https://www.slingbelt.com/products/las50-j-yel",
      js: "",
      i: "https://www.slingbelt.com/products/las50-i-yel",
      rj: "",
      ij: "https://www.slingbelt.com/products/las50-ij-yel",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/products/las50-e-yel",
      rtj: "",
    },
  },
  {
    type: "50mm",
    color: "gry",
    hx: "グレー",
    text: "保護スリーブ付き！",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm グレー の画像">',
    img_url: {
      r: "https://www.slingbelt.com/cdn/shop/files/lashing-rr_gr_01.jpg?width=160",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_gr_01.jpg?width=160",
      js: "https://www.slingbelt.com/cdn/shop/files/lashing-rjs_gr_01.jpg?width=160",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_gr_01.jpg?width=160",
      rj: "https://www.slingbelt.com/cdn/shop/files/lashing-rrj_gr_01.jpg?width=160",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_gr_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "https://www.slingbelt.com/cdn/shop/files/lashing-rd_gr_01.jpg?width=160",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re_gr_00.jpg?width=160",
      rtj: "https://www.slingbelt.com/cdn/shop/files/lashing-rtj_gr_01.jpg?width=160",
    },
    link_url: {
      r: "https://www.slingbelt.com/products/las50-r-gry",
      j: "https://www.slingbelt.com/products/las50-j-gry",
      js: "https://www.slingbelt.com/products/las50-js-gry",
      i: "https://www.slingbelt.com/products/las50-i-gry",
      rj: "https://www.slingbelt.com/products/las50-rj-gry",
      ij: "https://www.slingbelt.com/products/las50-ij-gry",
      s: "",
      st: "",
      f: "",
      d: "https://www.slingbelt.com/products/las50-d-gry",
      e: "https://www.slingbelt.com/products/las50-e-gry",
      rtj: "https://www.slingbelt.com/products/las50-js-gry-tj",
    },
  },
  {
    type: "50mm",
    color: "od",
    hx: "オリーブドラブ",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm オリーブドラブ の画像">',
    img_url: {
      r: "https://www.slingbelt.com/cdn/shop/files/lashing-rr_od_01.jpg?width=160",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_od_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_od_01.jpg?width=160",
      rj: "https://www.slingbelt.com/cdn/shop/files/lashing-rrj_od_01.jpg?width=160",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_od_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "https://www.slingbelt.com/cdn/shop/files/lashing-rd_od_01.jpg?width=160",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re_od_00.jpg?width=160",
      rtj: "https://www.slingbelt.com/cdn/shop/files/lashing-rtj_od_01.jpg?width=160",
    },
    link_url: {
      r: "https://www.slingbelt.com/products/las50-r-old",
      j: "https://www.slingbelt.com/products/las50-j-old",
      js: "",
      i: "https://www.slingbelt.com/products/las50-i-old",
      rj: "https://www.slingbelt.com/products/las50-rj-old",
      ij: "https://www.slingbelt.com/products/las50-ij-old",
      s: "",
      st: "",
      f: "",
      d: "https://www.slingbelt.com/products/las50-d-old",
      e: "https://www.slingbelt.com/products/las50-e-old",
      rtj: "https://www.slingbelt.com/products/las50-js-old-tj",
    },
  },
  {
    type: "50mm",
    color: "bc_blk-gr",
    hx: "ブラック/グレー",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm ブラック/グレー の画像">',
    img_url: {
      r: "https://www.slingbelt.com/cdn/shop/files/lashing-rr_bc_blk-gr_01.jpg?width=160",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_bc_blk-gr_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_bc_blk-gr_01.jpg?width=160",
      rj: "https://www.slingbelt.com/cdn/shop/files/lashing-rrj_bc_blk-gr_01.jpg?width=160",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_bc_blk-gr_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
    link_url: {
      r: "https://www.slingbelt.com/products/las50-r-blk-gr-bc",
      j: "https://www.slingbelt.com/products/las50-j-blk-gr-bc",
      js: "",
      i: "https://www.slingbelt.com/products/las50-i-blk-gr-bc",
      rj: "https://www.slingbelt.com/products/las50-rj-blk-gr-bc",
      ij: "https://www.slingbelt.com/products/las50-ij-blk-gr-bc",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
  },
  {
    type: "50mm",
    color: "bc_blk-wht",
    hx: "ブラック/ホワイト",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm ブラック/ホワイト の画像">',
    img_url: {
      r: "https://www.slingbelt.com/cdn/shop/files/lashing-rr_bc_blk-wht_01.jpg?width=160",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_bc_blk-wht_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_bc_blk-wht_01.jpg?width=160",
      rj: "https://www.slingbelt.com/cdn/shop/files/lashing-rrj_bc_blk-wht_01.jpg?width=160",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_bc_blk-wht_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
    link_url: {
      r: "https://www.slingbelt.com/products/las50-r-blk-wht-bc",
      j: "https://www.slingbelt.com/products/las50-j-blk-wht-bc",
      js: "",
      i: "https://www.slingbelt.com/products/las50-i-blk-wht-bc",
      rj: "https://www.slingbelt.com/products/las50-rj-blk-wht-bc",
      ij: "https://www.slingbelt.com/products/las50-ij-blk-wht-bc",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
  },
  {
    type: "50mm",
    color: "bc_od-blk",
    hx: "OD/ブラック",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm OD/ブラック の画像">',
    img_url: {
      r: "https://www.slingbelt.com/cdn/shop/files/lashing-rr_bc_od-blk_01.jpg?width=160",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_bc_od-blk_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_bc_od-blk_01.jpg?width=160",
      rj: "https://www.slingbelt.com/cdn/shop/files/lashing-rrj_bc_od-blk_01.jpg?width=160",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_bc_od-blk_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
    link_url: {
      r: "https://www.slingbelt.com/products/las50-r-od-blk-bc",
      j: "https://www.slingbelt.com/products/las50-j-od-blk-bc",
      js: "",
      i: "https://www.slingbelt.com/products/las50-i-od-blk-bc",
      rj: "https://www.slingbelt.com/products/las50-rj-od-blk-bc",
      ij: "https://www.slingbelt.com/products/las50-ij-od-blk-bc",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
  },
  {
    type: "50mm",
    color: "bc_wht-org",
    hx: "ホワイト/オレンジ",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm ホワイト/オレンジ の画像">',
    img_url: {
      r: "https://www.slingbelt.com/cdn/shop/files/lashing-rr_bc_wht-org_01.jpg?width=160",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_bc_wht-org_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_bc_wht-org_01.jpg?width=160",
      rj: "https://www.slingbelt.com/cdn/shop/files/lashing-rrj_bc_wht-org_01.jpg?width=160",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_bc_wht-org_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
    link_url: {
      r: "https://www.slingbelt.com/products/las50-r-wht-org-bc",
      j: "https://www.slingbelt.com/products/las50-j-wht-org-bc",
      js: "",
      i: "https://www.slingbelt.com/products/las50-i-wht-org-bc",
      rj: "https://www.slingbelt.com/products/las50-rj-wht-org-bc",
      ij: "https://www.slingbelt.com/products/las50-ij-wht-org-bc",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
  },
  {
    type: "50mm",
    color: "bcp_bp-yp",
    hx: '<span class="cl_compact">ブラック/イエロー[ 強化タイプ ]</span>',
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm ブラック/イエロー[強化タイプ] の画像">',
    img_url: {
      r: "",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_bcp_bp-yp_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_bcp_bp-yp_01.jpg?width=160",
      rj: "",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_bcp_bp-yp_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
    link_url: {
      r: "",
      j: "https://www.slingbelt.com/products/las50-j-blk-yel-bc",
      js: "",
      i: "https://www.slingbelt.com/products/las50-i-blk-yel-bc",
      rj: "",
      ij: "https://www.slingbelt.com/products/las50-ij-blk-yel-bc",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
  },
  {
    type: "50mm",
    color: "blu-ss",
    hx: "オールステンレス",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm オールステンレス の画像">',
    img_url: {
      r: "https://www.slingbelt.com/cdn/shop/files/lashing-rr_blu_ss_01.jpg?width=160",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj_blu_ss_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri_blu_ss_01.jpg?width=160",
      rj: "https://www.slingbelt.com/cdn/shop/files/lashing-rrj_blu_ss_01.jpg?width=160",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij_blu_ss_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re_blu_ss_01.jpg?width=160",
      rtj: "",
    },
    link_url: {
      r: "https://www.slingbelt.com/products/las50-r-blu-ss",
      j: "https://www.slingbelt.com/products/las50-j-blu-ss",
      js: "",
      i: "https://www.slingbelt.com/products/las50-i-blu-ss",
      rj: "https://www.slingbelt.com/products/las50-rj-blu-ss",
      ij: "https://www.slingbelt.com/products/las50-ij-blu-ss",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/products/las50-e-blu-ss",
      rtj: "",
    },
  },
  {
    type: "50mm",
    color: "blk-t",
    hx: "耐熱素材",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 50mm 耐熱素材 の画像">',
    img_url: {
      r: "",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj50t_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri50t_01.jpg?width=160",
      rj: "",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij50t_01.jpg?width=160",
      s: "",
      st: "",
      f: "https://www.slingbelt.com/cdn/shop/files/lashing-rf50t_01.jpg?width=160",
      d: "https://www.slingbelt.com/cdn/shop/files/lashing-rd50t_01.jpg?width=160",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re50t_01.jpg?width=160",
      rtj: "",
    },
    link_url: {
      r: "",
      j: "https://www.slingbelt.com/products/las50-j-blk-t",
      js: "",
      i: "https://www.slingbelt.com/products/las50-i-blk-t",
      rj: "",
      ij: "https://www.slingbelt.com/products/las50-ij-blk-t",
      s: "",
      st: "",
      f: "https://www.slingbelt.com/products/las50-f-blk-t",
      d: "https://www.slingbelt.com/products/las50-d-blk-t",
      e: "https://www.slingbelt.com/products/las50-e-blk-t",
      rtj: "",
    },
  },
  {
    type: "35mm",
    color: "35_org",
    hx: "オレンジ",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 35mm オレンジ の画像">',
    img_url: {
      r: "",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj35_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri35_01.jpg?width=160",
      rj: "",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij35_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re35_01.jpg?width=160",
      rtj: "",
    },
    link_url: {
      r: "",
      j: "https://www.slingbelt.com/products/las35-j-org",
      js: "",
      i: "https://www.slingbelt.com/products/las35-i-org",
      rj: "",
      ij: "https://www.slingbelt.com/products/las35-ij-org",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/products/las35-e-org",
      rtj: "",
    },
  },
  {
    type: "35mm",
    color: "35_wht",
    hx: "ホワイト",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 35mm ホワイト の画像">',
    img_url: {
      r: "",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj35_wht_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri35_wht_01.jpg?width=160",
      rj: "",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij35_wht_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re35_wht_01.jpg?width=160",
      rtj: "",
    },
    link_url: {
      r: "",
      j: "https://www.slingbelt.com/products/las35-j-wht",
      js: "",
      i: "https://www.slingbelt.com/products/las35-i-wht",
      rj: "",
      ij: "https://www.slingbelt.com/products/las35-ij-wht",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/products/las35-e-wht",
      rtj: "",
    },
  },
  {
    type: "35mm",
    color: "35_red",
    hx: "反射レッド",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 35mm 反射レッド の画像">',
    img_url: {
      r: "",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj35_rs_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri35_rs_01.jpg?width=160",
      rj: "",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij35_rs_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re35_rs_01.jpg?width=160",
      rtj: "",
    },
    link_url: {
      r: "",
      j: "https://www.slingbelt.com/products/las35-j-red-rs",
      js: "",
      i: "https://www.slingbelt.com/products/las35-i-red-rs",
      rj: "",
      ij: "https://www.slingbelt.com/products/las35-ij-red-rs",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/products/las35-e-red",
      rtj: "",
    },
  },
  {
    type: "25mm",
    color: "25_wht",
    hx: "ホワイト",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 25mm ホワイト の画像">',
    img_url: {
      r: "",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj25_wht_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri25_wht_01.jpg?width=160",
      rj: "",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij25_wht_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
    link_url: {
      r: "",
      j: "https://www.slingbelt.com/products/las25-j-wht",
      js: "",
      i: "https://www.slingbelt.com/products/las25-i-wht",
      rj: "",
      ij: "https://www.slingbelt.com/products/las25-ij-wht",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "",
      rtj: "",
    },
  },
  {
    type: "25mm",
    color: "25_blk-t",
    hx: "耐熱素材",
    text: "",
    img: '<img src="imgurl" alt="ラッシングベルト 25mm 耐熱素材 の画像">',
    img_url: {
      r: "",
      j: "https://www.slingbelt.com/cdn/shop/files/lashing-rj25t_01.jpg?width=160",
      js: "",
      i: "https://www.slingbelt.com/cdn/shop/files/lashing-ri25t_01.jpg?width=160",
      rj: "",
      ij: "https://www.slingbelt.com/cdn/shop/files/lashing-rij25t_01.jpg?width=160",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/cdn/shop/files/lashing-re25t_01.jpg?width=160",
      rtj: "",
    },
    link_url: {
      r: "",
      j: "https://www.slingbelt.com/products/las25-j-blk-t",
      js: "",
      i: "https://www.slingbelt.com/products/las25-i-blk-t",
      rj: "",
      ij: "https://www.slingbelt.com/products/las25-ij-blk-t",
      s: "",
      st: "",
      f: "",
      d: "",
      e: "https://www.slingbelt.com/products/las25-e-blk-t",
      rtj: "",
    },
  },
];

//スリングデータ ================================================================

var sb25_sling_step1 = [
  {
    hx: "25mm",
    js_ins_straight: "1t",
    js_ins_choke: "0.8t",
    js_ins_2p_45: "1.8t",
    js_ins_2p_90: "1.4t",
    js_ins_4p_45: "3.6t",
    js_ins_4p_90: "2.8t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-s251_01.jpg?&width=300" alt="スリングベルト 25mm幅の画像">',
    color: "ヴァイオレット",
    ibu: "240mm(最小)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/slg25?variant=41799429652616",
      },
      {
        length: "1.5m",
        url: "https://www.slingbelt.com/products/slg25?variant=41799429685384",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/slg25?variant=41799429718152",
      },
      {
        length: "2.5m",
        url: "https://www.slingbelt.com/products/slg25?variant=43479361552520",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/slg25?variant=41799429750920",
      },
      {
        length: "3.5m",
        url: "https://www.slingbelt.com/products/slg25?variant=43479362568328",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/slg25?variant=41799429783688",
      },
      {
        length: "4.5m",
        url: "https://www.slingbelt.com/products/slg25?variant=43479364010120",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/slg25?variant=41799429816456",
      },
      {
        length: "5.5m",
        url: "https://www.slingbelt.com/products/slg25?variant=43479364305032",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/slg25?variant=41799429849224",
      },
    ],
  },
  {
    hx: "50mm",
    js_ins_straight: "2t",
    js_ins_choke: "1.6t",
    js_ins_2p_45: "3.6t",
    js_ins_2p_90: "2.8t",
    js_ins_4p_45: "7.2t",
    js_ins_4p_90: "5.6t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-s501_01.jpg?&width=300" alt="スリングベルト 50mm幅の画像">',
    color: "グリーン",
    ibu: "280mm(最小)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/slg50?variant=41826491662472",
      },
      {
        length: "1.5m",
        url: "https://www.slingbelt.com/products/slg50?variant=41826491695240",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/slg50?variant=41826491728008",
      },
      {
        length: "2.5m",
        url: "https://www.slingbelt.com/products/slg50?variant=43479365091464",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/slg50?variant=41826491760776",
      },
      {
        length: "3.5m",
        url: "https://www.slingbelt.com/products/slg50?variant=43479365189768",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/slg50?variant=41826491793544",
      },
      {
        length: "4.5m",
        url: "https://www.slingbelt.com/products/slg50?variant=43479365222536",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/slg50?variant=41826491826312",
      },
      {
        length: "5.5m",
        url: "https://www.slingbelt.com/products/slg50?variant=43479365451912",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/slg50?variant=41826491859080",
      },
      {
        length: "6.5m",
        url: "https://www.slingbelt.com/products/slg50?variant=43479367811208",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/slg50?variant=41826491891848",
      },
      {
        length: "7.5m",
        url: "https://www.slingbelt.com/products/slg50?variant=43479367876744",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/slg50?variant=41826491924616",
      },
      {
        length: "8.5m",
        url: "https://www.slingbelt.com/products/slg50?variant=43479367909512",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/slg50?variant=41826491957384",
      },
    ],
  },
  {
    hx: "75mm",
    js_ins_straight: "3t",
    js_ins_choke: "2.4t",
    js_ins_2p_45: "5.4t",
    js_ins_2p_90: "4.2t",
    js_ins_4p_45: "10.8t",
    js_ins_4p_90: "8.4t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-s751_01.jpg?&width=300" alt="スリングベルト 75mm幅の画像">',
    color: "イエロー",
    ibu: "320mm(最小)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/slg75?variant=41826683420808",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/slg75?variant=41826683453576",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/slg75?variant=41826683486344",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/slg75?variant=41826683519112",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/slg75?variant=41826683551880",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/slg75?variant=41826683584648",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/slg75?variant=41826683617416",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/slg75?variant=41826683650184",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/slg75?variant=41826683715720",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/slg75?variant=41826683748488",
      },
    ],
  },
  {
    hx: "100mm",
    js_ins_straight: "4t",
    js_ins_choke: "3.2t",
    js_ins_2p_45: "7.2t",
    js_ins_2p_90: "5.6t",
    js_ins_4p_45: "14.4t",
    js_ins_4p_90: "11.2t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-s1001_01.jpg?&width=300" alt="スリングベルト 100mm幅の画像">',
    color: "グレー",
    ibu: "360mm(最小)",
    variations: [
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/slg100?variant=41826702098568",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/slg100?variant=41826702131336",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/slg100?variant=41826702164104",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/slg100?variant=41826702196872",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/slg100?variant=41826702229640",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/slg100?variant=41826702262408",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/slg100?variant=41826702295176",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/slg100?variant=41826702327944",
      },
      {
        length: "12m",
        url: "https://www.slingbelt.com/products/slg100?variant=41826702360712",
      },
      {
        length: "14m",
        url: "https://www.slingbelt.com/products/slg100?variant=41826702393480",
      },
      {
        length: "15m",
        url: "https://www.slingbelt.com/products/slg100?variant=41826702426248",
      },
    ],
  },
  {
    hx: "150mm",
    js_ins_straight: "6t",
    js_ins_choke: "4.8t",
    js_ins_2p_45: "10.8t",
    js_ins_2p_90: "8.4t",
    js_ins_4p_45: "21.6t",
    js_ins_4p_90: "16.8t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-s1501_01.jpg?&width=300" alt="スリングベルト 150mm幅の画像">',
    color: "ブラウン",
    ibu: "460mm(最小)",
    variations: [
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/slg150?variant=41848177524872",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/slg150?variant=41848177557640",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/slg150?variant=41848177590408",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/slg150?variant=41848177623176",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/slg150?variant=41848177655944",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/slg150?variant=41848177688712",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/slg150?variant=41848177721480",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/slg150?variant=41848177754248",
      },
      {
        length: "12m",
        url: "https://www.slingbelt.com/products/slg150?variant=41848177787016",
      },
      {
        length: "14m",
        url: "https://www.slingbelt.com/products/slg150?variant=41848177819784",
      },
      {
        length: "15m",
        url: "https://www.slingbelt.com/products/slg150?variant=41848177852552",
      },
    ],
  },
  {
    hx: "200mm",
    js_ins_straight: "8t",
    js_ins_choke: "6.4t",
    js_ins_2p_45: "14.4t",
    js_ins_2p_90: "11.2t",
    js_ins_4p_45: "28.8t",
    js_ins_4p_90: "22.4t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-s200_01.jpg?&width=300" alt="スリングベルト 200mm幅の画像">',
    color: "ブルー",
    ibu: "560mm(最小)",
    variations: [
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/slg200?variant=41826707505288",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/slg200?variant=41826707538056",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/slg200?variant=41826707570824",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/slg200?variant=41826707603592",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/slg200?variant=41826707636360",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/slg200?variant=41826707669128",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/slg200?variant=41826707701896",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/slg200?variant=41826707734664",
      },
      {
        length: "12m",
        url: "https://www.slingbelt.com/products/slg200?variant=41826707767432",
      },
      {
        length: "14m",
        url: "https://www.slingbelt.com/products/slg200?variant=41826707800200",
      },
      {
        length: "15m",
        url: "https://www.slingbelt.com/products/slg200?variant=41826707832968",
      },
    ],
  },
  {
    hx: "300mm",
    js_ins_straight: "10t",
    js_ins_choke: "8.0t",
    js_ins_2p_45: "18.0t",
    js_ins_2p_90: "14.0t",
    js_ins_4p_45: "36.0",
    js_ins_4p_90: "28.0",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-s300_01.jpg?&width=300" alt="スリングベルト 300mm幅の画像">',
    color: "オレンジ",
    ibu: "700mm(最小)",
    variations: [
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/slg300?variant=41826713960584",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/slg300?variant=41826713993352",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/slg300?variant=41826714026120",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/slg300?variant=41826714058888",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/slg300?variant=41826714091656",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/slg300?variant=41826714124424",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/slg300?variant=41826714157192",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/slg300?variant=41826714189960",
      },
      {
        length: "12m",
        url: "https://www.slingbelt.com/products/slg300?variant=41826714222728",
      },
      {
        length: "14m",
        url: "https://www.slingbelt.com/products/slg300?variant=41826714255496",
      },
      {
        length: "15m",
        url: "https://www.slingbelt.com/products/slg300?variant=41826714288264",
      },
    ],
  },
];

//ラウンドスリングデータ ================================================================

var sb25_round_step1 = [
  {
    hx: "1t用",
    js_ins_straight: "1t",
    js_ins_choke: "0.8t",
    js_ins_2p_45: "1.8t",
    js_ins_2p_90: "1.4t",
    js_ins_4p_45: "3.6t",
    js_ins_4p_90: "2.8t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-rs1_01.jpg?&width=300" alt="ラウンドスリング 1t用の画像">',
    color: "ヴァイオレット",
    ibu: "Φ18 (Φ36)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds1?variant=41799914356872",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds1?variant=41799914389640",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds1?variant=41799914422408",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds1?variant=41799914455176",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds1?variant=41799914487944",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds1?variant=41799914520712",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds1?variant=41799914553480",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds1?variant=41799914586248",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds1?variant=41799914619016",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds1?variant=41799914651784",
      },
    ],
  },
  {
    hx: "2t用",
    js_ins_straight: "2t",
    js_ins_choke: "1.6t",
    js_ins_2p_45: "3.6t",
    js_ins_2p_90: "2.8t",
    js_ins_4p_45: "7.2t",
    js_ins_4p_90: "5.6t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-rs2_01.jpg?&width=300" alt="ラウンドスリング 1t用の画像">',
    color: "グリーン",
    ibu: "Φ18 (Φ36)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds2?variant=41833545465992",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds2?variant=41833545498760",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds2?variant=41833545531528",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds2?variant=41833545564296",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds2?variant=41833545597064",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds2?variant=41833545629832",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds2?variant=41833545662600",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds2?variant=41833545695368",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds2?variant=41833545728136",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds2?variant=41833545760904",
      },
    ],
  },
  {
    hx: "3t用",
    js_ins_straight: "3t",
    js_ins_choke: "2.4t",
    js_ins_2p_45: "5.4t",
    js_ins_2p_90: "4.2t",
    js_ins_4p_45: "10.8t",
    js_ins_4p_90: "8.4t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-rs3_01.jpg?&width=300" alt="ラウンドスリング 3t用の画像">',
    color: "イエロー",
    ibu: "Φ25 (Φ48)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds3?variant=41833579610248",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds3?variant=41833579643016",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds3?variant=41833579675784",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds3?variant=41833579708552",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds3?variant=41833579741320",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds3?variant=41833579774088",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds3?variant=41833579806856",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds3?variant=41833579839624",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds3?variant=41833579872392",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds3?variant=41833579905160",
      },
    ],
  },
  {
    hx: "4t用",
    js_ins_straight: "4t",
    js_ins_choke: "3.2t",
    js_ins_2p_45: "7.2t",
    js_ins_2p_90: "5.6t",
    js_ins_4p_45: "14.4t",
    js_ins_4p_90: "11.2t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-rs4_01.jpg?&width=300" alt="ラウンドスリング 4t用の画像">',
    color: "グレー",
    ibu: "Φ27 (Φ48)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds4?variant=41833569910920",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds4?variant=41833569943688",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds4?variant=41833569976456",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds4?variant=41833570009224",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds4?variant=41833570041992",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds4?variant=41833570074760",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds4?variant=41833570107528",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds4?variant=41833570140296",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds4?variant=41833570173064",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds4?variant=41833570205832",
      },
    ],
  },
  {
    hx: "5t用",
    js_ins_straight: "5t",
    js_ins_choke: "4.0t",
    js_ins_2p_45: "9.0t",
    js_ins_2p_90: "7.0t",
    js_ins_4p_45: "18.0t",
    js_ins_4p_90: "14.0t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-rs5_01.jpg?&width=300" alt="ラウンドスリング 5t用の画像">',
    color: "レッド",
    ibu: "Φ29 (Φ48)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds5?variant=41833582985352",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds5?variant=41833583018120",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds5?variant=41833583050888",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds5?variant=41833583083656",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds5?variant=41833583116424",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds5?variant=41833583149192",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds5?variant=41833583181960",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds5?variant=41833583214728",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds5?variant=41833583247496",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds5?variant=41833583280264",
      },
    ],
  },
  {
    hx: "6t用",
    js_ins_straight: "6t",
    js_ins_choke: "4.8t",
    js_ins_2p_45: "10.8t",
    js_ins_2p_90: "8.4t",
    js_ins_4p_45: "21.6t",
    js_ins_4p_90: "16.8t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-rs6_01.jpg?&width=300" alt="ラウンドスリング 6t用の画像">',
    color: "ブラウン",
    ibu: "Φ31 (Φ52)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds6?variant=41833586163848",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds6?variant=41833586196616",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds6?variant=41833586229384",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds6?variant=41833586262152",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds6?variant=41833586294920",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds6?variant=41833586327688",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds6?variant=41833586360456",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds6?variant=41833586393224",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds6?variant=41833586425992",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds6?variant=41833586458760",
      },
    ],
  },
  {
    hx: "8t用",
    js_ins_straight: "8t",
    js_ins_choke: "6.4t",
    js_ins_2p_45: "14.4t",
    js_ins_2p_90: "11.2t",
    js_ins_4p_45: "28.8t",
    js_ins_4p_90: "22.4t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-rs8_01.jpg?&width=300" alt="ラウンドスリング 8t用の画像">',
    color: "ブルー",
    ibu: "Φ35 (Φ56)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds8?variant=41833587638408",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds8?variant=41833587671176",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds8?variant=41833587703944",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds8?variant=41833587736712",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds8?variant=41833587769480",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds8?variant=41833587802248",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds8?variant=41833587835016",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds8?variant=41833587867784",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds8?variant=41833587900552",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds8?variant=41833587933320",
      },
    ],
  },
  {
    hx: "10t用",
    js_ins_straight: "10t",
    js_ins_choke: "8.0t",
    js_ins_2p_45: "18.0t",
    js_ins_2p_90: "14.0t",
    js_ins_4p_45: "36.0t",
    js_ins_4p_90: "28.0t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-rs10_01.jpg?&width=300" alt="ラウンドスリング 10t用の画像">',
    color: "オレンジ",
    ibu: "Φ43 (Φ68)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833588719752",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833588752520",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833588785288",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833588818056",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833588850824",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833588883592",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833588916360",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833588949128",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833588981896",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833589014664",
      },
      {
        length: "15m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833589047432",
      },
      {
        length: "20m",
        url: "https://www.slingbelt.com/products/rds10?variant=41833589080200",
      },
    ],
  },
  {
    hx: "15t用",
    js_ins_straight: "15t",
    js_ins_choke: "12.0t",
    js_ins_2p_45: "27.0t",
    js_ins_2p_90: "21.0t",
    js_ins_4p_45: "54.0t",
    js_ins_4p_90: "42.0t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-rs15_01.png?&width=300" alt="ラウンドスリング 15t用の画像">',
    color: "オレンジ",
    ibu: "Φ48 (Φ74)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592029320",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592062088",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592094856",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592127624",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592160392",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592193160",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592225928",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592258696",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592291464",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592324232",
      },
      {
        length: "15m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592357000",
      },
      {
        length: "20m",
        url: "https://www.slingbelt.com/products/rds15?variant=41833592389768",
      },
    ],
  },
  {
    hx: "20t用",
    js_ins_straight: "20t",
    js_ins_choke: "16.0t",
    js_ins_2p_45: "36.0t",
    js_ins_2p_90: "28.0t",
    js_ins_4p_45: "72.0t",
    js_ins_4p_90: "56.0t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-rs20_01.png?&width=300" alt="ラウンドスリング 20t用の画像">',
    color: "オレンジ",
    ibu: "Φ58 (Φ80)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833610936456",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833610969224",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833611001992",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833611034760",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833611067528",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833611100296",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833611133064",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833611165832",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833611198600",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833611231368",
      },
      {
        length: "15m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833611264136",
      },
      {
        length: "20m",
        url: "https://www.slingbelt.com/products/rds20?variant=41833611296904",
      },
    ],
  },
  {
    hx: '8t用<span class="sb25_common_brackets sb25_common_fc_org">軽量型</span>',
    js_ins_straight: "8.0t",
    js_ins_choke: "6.4t",
    js_ins_2p_45: "14.4t",
    js_ins_2p_90: "11.2t",
    js_ins_4p_45: "28.8t",
    js_ins_4p_90: "22.4t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-pe_rs8_01.jpg?&width=300" alt="軽量ラウンドスリング 8t用の画像">',
    color: "オレンジ",
    ibu: "Φ30 (Φ52)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611493512",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611526280",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611559048",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611591816",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611624584",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611657352",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611690120",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611722888",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611755656",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611788424",
      },
      {
        length: "15m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611821192",
      },
      {
        length: "20m",
        url: "https://www.slingbelt.com/products/rds8-pe?variant=41833611853960",
      },
    ],
  },
  {
    hx: '10t用<span class="sb25_common_brackets sb25_common_fc_org">軽量型</span>',
    js_ins_straight: "10.0t",
    js_ins_choke: "8.0t",
    js_ins_2p_45: "18.0t",
    js_ins_2p_90: "14.0t",
    js_ins_4p_45: "36.0t",
    js_ins_4p_90: "28.0t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-pe_rs10_01.jpg?&width=300" alt="軽量ラウンドスリング 10t用の画像">',
    color: "オレンジ",
    ibu: "Φ38 (Φ56)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628172424",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628205192",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628237960",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628270728",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628303496",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628336264",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628369032",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628401800",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628434568",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628467336",
      },
      {
        length: "15m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628500104",
      },
      {
        length: "20m",
        url: "https://www.slingbelt.com/products/rds10-pe?variant=41833628532872",
      },
    ],
  },
  {
    hx: '15t用<span class="sb25_common_brackets sb25_common_fc_org">軽量型</span>',
    js_ins_straight: "15.0t",
    js_ins_choke: "12.0t",
    js_ins_2p_45: "27.0t",
    js_ins_2p_90: "21.0t",
    js_ins_4p_45: "54.0t",
    js_ins_4p_90: "42.0t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-pe_rs15_01.jpg?&width=300" alt="軽量ラウンドスリング 15t用の画像">',
    color: "オレンジ",
    ibu: "Φ46 (Φ68)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629515912",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629548680",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629581448",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629614216",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629646984",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629679752",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629712520",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629745288",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629778056",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629810824",
      },
      {
        length: "15m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629843592",
      },
      {
        length: "20m",
        url: "https://www.slingbelt.com/products/rds15-pe?variant=41833629876360",
      },
    ],
  },
  {
    hx: '20t用<span class="sb25_common_brackets sb25_common_fc_org">軽量型</span>',
    js_ins_straight: "20.0t",
    js_ins_choke: "16.0t",
    js_ins_2p_45: "36.0t",
    js_ins_2p_90: "28.0t",
    js_ins_4p_45: "72.0t",
    js_ins_4p_90: "56.0t",
    image:
      '<img src="https://www.slingbelt.com/cdn/shop/files/sling-pe_rs20_01.jpg?&width=300" alt="軽量ラウンドスリング 20t用の画像">',
    color: "オレンジ",
    ibu: "Φ54 (Φ74)",
    variations: [
      {
        length: "1m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630400648",
      },
      {
        length: "2m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630433416",
      },
      {
        length: "3m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630466184",
      },
      {
        length: "4m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630498952",
      },
      {
        length: "5m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630531720",
      },
      {
        length: "6m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630564488",
      },
      {
        length: "7m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630597256",
      },
      {
        length: "8m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630630024",
      },
      {
        length: "9m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630662792",
      },
      {
        length: "10m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630695560",
      },
      {
        length: "15m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630728328",
      },
      {
        length: "20m",
        url: "https://www.slingbelt.com/products/rds20-pe?variant=41833630761096",
      },
    ],
  },
];

//その他の商品データ =============================
var sb25_other_step1 = [
  {
    hx: "その他の25mm幅ベルト",
    text: "カムバックル、サインベルト、タイダウンベルト、サブベルトなど。<br>",
    variations: [
      {
        hx: "カムバックルベルト",
        url: "https://www.slingbelt.com/collections/types?q=cambucklebelt",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-cum_blk_01.png?&width=100" alt="カムバックルベルト の画像">',
        text: "エンドレスタイプのカムバックルベルトです。",
      },
      {
        hx: "サインベルト",
        url: "https://www.slingbelt.com/search?q=%E3%82%B5%E3%82%A4%E3%83%B3%E3%83%99%E3%83%AB%E3%83%88&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.products._type=lashingbelt&sort_by=relevance",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-cum_yel_s01.png?&width=100" alt="サインベルト の画像">',
        text: "カムバックルベルトにあらかじめ注意喚起が印字された商品です。",
      },
      {
        hx: "タイダウンベルト",
        url: "https://www.slingbelt.com/products/tdb",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-tdblk_01.png?&width=100" alt="タイダウンベルト の画像">',
        text: "4種のカラーから選べるタイダウンベルトです。",
      },
      {
        hx: "サブベルト",
        url: "https://www.slingbelt.com/products/sb-belt",
        img: '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/lashing-subbred_05.jpg?&width=100" alt="サブベルト の画像">',
        text: "2本セットのサブベルトです。<br>フックによる傷の防止にも役立ちます",
      },
    ],
  },
  {
    hx: "ベルト保護資材",
    text: "ラッシングベルト用だけでなく、スリングベルト用や<br>ラウンドスリング用も取り扱っています。",
    variations: [
      {
        hx: "50mm幅ラッシングベルト用<br>保護資材",
        url: "https://www.slingbelt.com/search?q=%E4%BF%9D%E8%AD%B7%E3%80%80%E3%83%A9%E3%83%83%E3%82%B7%E3%83%B3%E3%82%B0&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.products._type=belt_parts&sort_by=relevance",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-hogo_01.jpg?&width=100" alt="ラッシングベルト用 保護スリーブ の画像">',
        text: "50mm幅のラッシングベルト専用の<br>保護資材です。",
      },
      {
        hx: "スリングベルト用保護資材",
        url: "https://www.slingbelt.com/search?q=%E4%BF%9D%E8%AD%B7%E3%80%80%E3%82%B9%E3%83%AA%E3%83%B3%E3%82%B0%E3%83%99%E3%83%AB%E3%83%88&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.products._type=belt_parts&sort_by=relevance",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-hogo-sling25_01.jpg?&width=100" alt="スリングベルト保護パッド25mm幅用 の画像">',
        text: "マジックテープ式保護パッドです。<br>ベルト幅に合わせ種類を選べます。",
      },
      {
        hx: "ラウンドスリング用保護資材",
        url: "https://www.slingbelt.com/search?q=%E4%BF%9D%E8%AD%B7%E3%80%80%E3%83%A9%E3%82%A6%E3%83%B3%E3%83%89%E3%82%B9%E3%83%AA%E3%83%B3%E3%82%B0&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.products._type=belt_parts&sort_by=relevance",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/sling-hogo-round2_01.jpg?&width=100" alt="ラウンドスリング保護パッド1t〜2t用 の画像">',
        text: "マジックテープ式保護パッドです。<br>使用荷重に合わせ種類を選べます。",
      },
    ],
  },
  {
    hx: "ロープタイオフ",
    text: "トラックレールと合わせて使用する補助器具です。<br>4種のフックに複数のカラーバリエーションをご用意。",
    variations: [
      {
        hx: "Jフック",
        url: "https://www.slingbelt.com/search?q=%E3%83%AD%E3%83%BC%E3%83%97%E3%82%BF%E3%82%A4%E3%82%AA%E3%83%95+J%E3%83%95%E3%83%83%E3%82%AF+-%E3%83%AD%E3%83%B3%E3%82%B0&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.belt._type=j_hook&sort_by=relevance",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-rac_j01.jpg?&width=100" alt="Jフック ブルー の画像">',
        text: "ブルー・ブラック・レッドの3種類を<br>ご用意。",
      },
      {
        hx: "デルタリング",
        url: "https://www.slingbelt.com/search?q=%E3%83%AD%E3%83%BC%E3%83%97%E3%82%BF%E3%82%A4%E3%82%AA%E3%83%95+%E3%83%87%E3%83%AB%E3%82%BF%E3%83%AA%E3%83%B3%E3%82%B0&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.products._type=belt_parts&sort_by=relevance",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-rac_d01.jpg?&width=100" alt="デルタリング ブルー の画像">',
        text: "ブルー・ブラック・レッドの3種類を<br>ご用意。",
      },
      {
        hx: "スナップフック",
        url: "https://www.slingbelt.com/search?q=%E3%83%AD%E3%83%BC%E3%83%97%E3%82%BF%E3%82%A4%E3%82%AA%E3%83%95+%E3%82%B9%E3%83%8A%E3%83%83%E3%83%97%E3%83%95%E3%83%83%E3%82%AF&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.products._type=belt_parts&sort_by=relevance",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-rac_s01.jpg?&width=100" alt="スナップフック ブルー の画像">',
        text: "ブルー・レッドの2種類をご用意。",
      },
      {
        hx: "Iフック/ IJフック",
        url: "https://www.slingbelt.com/search?q=%E3%83%AD%E3%83%BC%E3%83%97%E3%82%BF%E3%82%A4%E3%82%AA%E3%83%95+IJ%E3%83%95%E3%83%83%E3%82%AF&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.products._type=belt_parts&sort_by=relevance",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-rac_l_ij_01.jpg?&width=100" alt="Iフック/ IJフック ブルー の画像">',
        text: "ブルー・ブラック・レッドと<br>オレンジ(35mm幅)の4種類を<br>ご用意。",
      },
    ],
  },
  {
    hx: "その他のベルト用パーツ",
    text: "ベルト原反、アイフック抜け止めホルダー、バックル、<br>メンテナンススプレーなど。",
    variations: [
      // {
      //   hx: "ベルト保護資材",
      //   url: "https://www.slingbelt.com/search?q=%E4%BF%9D%E8%AD%B7&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.products._type=belt_parts&sort_by=relevance",
      //   img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-hogo_01.jpg?&width=100" alt="ラッシングベルト用 保護スリーブ の画像">',
      //   text: "各幅のラッシングベルト、<br>スリング、ラウンドに対応。",
      // },
      // {
      //   hx: "ロープタイオフ",
      //   url: "https://www.slingbelt.com/collections/beltparts?filter.p.m.products._type=belt_parts&filter.p.product_type=ropetie",
      //   img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-rac_d01.jpg?&width=100" alt="ロープタイオフ の画像">',
      //   text: "4種のフックと複数のカラーから<br>自由に選べます。",
      // },
      {
        hx: "ベルト原反",
        url: "https://www.slingbelt.com/collections/beltparts?filter.p.m.products._type=belt_parts&filter.p.product_type=fabric",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/backle-40mm_01.png?&width=100" alt="ベルト原反 の画像">',
        text: "40mm幅・50mm幅商品あり。<br>1m単位で切り売り可能です。",
      },
      {
        hx: "Iフック抜け止めホルダー",
        url: "https://www.slingbelt.com/search?q=I%E3%83%95%E3%83%83%E3%82%AF%E3%83%9B%E3%83%AB%E3%83%80%E3%83%BC&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.products._type=belt_parts&sort_by=relevance",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-i_fhd_pnk01.jpg?&width=100" alt="Iフック抜け止めホルダー の画像">',
        text: "ロープフックの抜け防止に。<br>別名：ワッカ、アイタイプ。",
      },
      {
        hx: "バックル",
        url: "https://www.slingbelt.com/collections/beltparts?filter.p.m.products._type=belt_parts&filter.p.product_type=buckle",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/backle-r50_backle_01.png?&width=100" alt="ラチェットバックル の画像">',
        text: "ラチェットバックルだけでなく、<br>スクエアバックルもあります。",
      },
      {
        hx: "メンテナンススプレー",
        url: "https://www.slingbelt.com/collections/beltparts?filter.p.m.products._type=belt_parts&filter.p.product_type=spray",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-msp-1_01.jpg?&width=100" alt="メンテナンススプレー の画像">',
        text: "ラチェットバックル専用の<br>メンテナンススプレーです。",
      },
      {
        hx: "レバーホイスト",
        url: "https://www.slingbelt.com/collections/lever_hoist",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/leverhoist_nk016-001.jpg?&width=100" alt="レバーホイストの画像">',
        text: "丈夫でありながら軽量・コンパクト設計を実現した高性能レバーホイストです。",
      },
    ],
  },
  {
    hx: "一斗缶取っ手！とってちゃん",
    text: "一斗缶の持ち運び用ベルト！金具の無いコンパクト仕様。<br>携帯・収納にも便利なアイテムです。",
    variations: [
      {
        hx: "詳しい商品紹介",
        url: "https://www.slingbelt.com/pages/20220419tottechan",
        img: '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/20220419tottechan-1.jpg?&width=100" alt="とってちゃんが装着された一斗缶の画像">',
        text: "商品の特徴や装着方法などを<br>わかりやすくご紹介。",
      },
      {
        hx: "カラー：黒",
        url: "https://www.slingbelt.com/products/ttc?variant=41840883433608",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-ttc_01_blk_01.jpg.jpg?&width=100" alt="一斗缶取っ手！とってちゃん 黒 の画像">',
        text: "定番のブラックカラーです。",
      },
      {
        hx: "カラー：黄",
        url: "https://www.slingbelt.com/products/ttc?variant=41840883466376",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-ttc_01_yel_01.jpg.jpg?&width=100" alt="一斗缶取っ手！とってちゃん 黄 の画像">',
        text: "目立ちやすさなら<br>黄色がオススメです。",
      },
      {
        hx: "カラー：赤",
        url: "https://www.slingbelt.com/products/ttc?variant=41840883499144",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-ttc_01_red_01.jpg.jpg?&width=100" alt="一斗缶取っ手！とってちゃん 赤 の画像">',
        text: "色分けに便利な赤色もご用意！",
      },
      {
        hx: "カラー：青",
        url: "https://www.slingbelt.com/products/ttc?variant=41840883531912",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/lashing-ttc_01_blu_01.jpg.jpg?&width=100" alt="一斗缶取っ手！とってちゃん 青 の画像">',
        text: "色分けに便利な青色もご用意！",
      },
    ],
  },
  {
    hx: "ショーリングバー",
    text: "別名をラッシングバーとも呼ばれています。<br>トラックの荷締め補助に使用する金属製のバーです。",
    variations: [
      {
        hx: "1560mm〜1840mm",
        url: "https://www.slingbelt.com/products/srb-fdb1560",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/deack-s_fdb01.jpg?&width=100" alt="ショーリングバー 1560mm〜1840mm の画像">',
        text: "重量:7.7㎏、垂直荷重：900㎏、<br>ポリウレタン製の取手付き",
      },
      {
        hx: "1780mm〜2060mm",
        url: "https://www.slingbelt.com/products/srb-fdb1780",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/deack-s_fdb01.jpg?&width=100" alt="ショーリングバー 1780mm〜2060mm の画像">',
        text: "重量:8.0㎏、垂直荷重：900㎏、<br>ポリウレタン製の取手付き",
      },
      {
        hx: "2000mm〜2280mm",
        url: "https://www.slingbelt.com/products/srb-fdb2000",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/deack-s_fdb01.jpg?&width=100" alt="ショーリングバー 2000mm〜2280mm の画像">',
        text: "重量:8.3㎏、垂直荷重：900㎏、<br>ポリウレタン製の取手付き",
      },
      {
        hx: "2220mm〜2500mm",
        url: "https://www.slingbelt.com/products/srb-fdb2220",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/deack-s_fdb01.jpg?&width=100" alt="ショーリングバー 2220mm〜2500mm の画像">',
        text: "重量:8.6㎏、垂直荷重：900㎏、<br>ポリウレタン製の取手付き",
      },
    ],
  },
  {
    hx: "燃料ホース",
    text: "フューエルホースやオイルホースとも呼ばれています。<br>保護層ありのホースや透明なホースなど種類豊富。",
    variations: [
      {
        hx: "内層ブレード",
        url: "https://www.slingbelt.com/search?q=%E5%86%85%E5%B1%A4%E3%83%96%E3%83%AC%E3%83%BC%E3%83%89&options%5Bprefix%5D=last",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/fuel-in76_01.png?&width=100" alt="燃料ホース 内層ブレード の画像">',
        text: "内部に補強材があるタイプです。<br>切り売り商品もございます。",
      },
      {
        hx: "外層ブレード",
        url: "https://www.slingbelt.com/search?q=%E5%A4%96%E5%B1%A4%E3%83%96%E3%83%AC%E3%83%BC%E3%83%89&options%5Bprefix%5D=last",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/fuel-out62_01.png?&width=100" alt="燃料ホース 外層ブレード の画像">',
        text: "外側が補強されたタイプです。<br>切り売り商品もございます。",
      },
      {
        hx: "補強層なし・ブラック",
        url: "https://www.slingbelt.com/search?q=%E8%A3%9C%E5%BC%B7%E5%B1%A4%E3%81%AA%E3%81%97+-%E3%83%94%E3%83%B3%E3%82%AF&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.m.products._type=hoses&sort_by=relevance",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/fuel-no4_01.png?&width=100" alt="燃料ホース 補強層なし・ブラック の画像">',
        text: "補強層が無いタイプの黒色です。<br>切り売り商品もございます。",
      },
      {
        hx: "補強層なし・ピンク",
        url: "https://www.slingbelt.com/search?q=%E8%A3%9C%E5%BC%B7%E5%B1%A4%E3%81%AA%E3%81%97+%E3%83%94%E3%83%B3%E3%82%AF&options%5Bprefix%5D=last",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/fuel-nop95_01.png?&width=100" alt="燃料ホース 補強層なし・ピンク の画像">',
        text: "補強層が無いタイプのピンク色です。<br>切り売り商品もございます。",
      },
      {
        hx: "ホース用バンド",
        url: "https://www.slingbelt.com/search?q=%E3%83%9B%E3%83%BC%E3%82%B9%E7%94%A8%E3%83%90%E3%83%B3%E3%83%89&options%5Bprefix%5D=last&filter.v.price.gte=&filter.v.price.lte=&filter.p.product_type=band_hose&sort_by=relevance",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/fuel-hs_1.png?&width=100" alt="ホース用バンド の画像">',
        text: "ホースに合わせて、<br>様々なサイズをご用意。",
      },
    ],
  },
  {
    hx: "ウォーターホース",
    text: "ヒーター・ラジエター・サブタンク・バイパスに使用可能な<br>自動車用ホースです。太さも選べ、切り売りも対応OK。",
    variations: [
      {
        hx: "内径 6mm ~ 19㎜",
        url: "https://www.slingbelt.com/collections/waterhose?filter.p.m.products._type=hoses&filter.p.product_type=inner6to19",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/water-1.jpg?&width=100" alt="ウォーターホース 内径 6mm ~ 19㎜ の画像">',
        text: "内径が6.0mm〜19.0㎜のホース。<br>切り売り商品もございます。",
      },
      {
        hx: "内径 22mm - 57㎜",
        url: "https://www.slingbelt.com/collections/waterhose?filter.p.m.products._type=hoses&filter.p.product_type=inner22to57",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/water-1.jpg?&width=100" alt="ウォーターホース 内径 22mm - 57㎜ の画像">',
        text: "内径が22.0mm〜57.0㎜のホース。<br>切り売り商品はありません。",
      },
      {
        hx: "L型",
        url: "https://www.slingbelt.com/collections/waterhose?filter.p.m.products._type=hoses&filter.p.product_type=l_type_inner19to49",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/water-2.jpg?&width=100" alt="ウォーターホース L型 の画像">',
        text: "L型型に曲がっているホース。<br>切り売り商品はありません。",
      },
    ],
  },
  {
    hx: "高圧洗浄機用ホース",
    text: "高圧温水洗浄機で使用できるホースです。<br>超高圧対応のホースのライナップもあります。",
    variations: [
      {
        hx: "超高圧対応 3/8サイズ",
        url: "https://www.slingbelt.com/search?q=%E8%B6%85%E9%AB%98%E5%9C%A7&options%5Bprefix%5D=last",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/high-1.jpg?&width=100" alt="高圧洗浄機用ホース の画像">',
        text: "超高圧対応です。<br>2種類から長さを選べます。",
      },
      {
        hx: "高圧のみ 3/8サイズ",
        url: "https://www.slingbelt.com/search?q=%E9%AB%98%E5%9C%A7+3%2F8+-%E8%B6%85%E9%AB%98%E5%9C%A7&options%5Bprefix%5D=last",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/high-1.jpg?&width=100" alt="高圧洗浄機用ホース の画像">',
        text: "通常タイプの3/8サイズです。<br>3種類から長さを選べます。",
      },
      {
        hx: "高圧のみ 1/4サイズ",
        url: "https://www.slingbelt.com/search?q=%E9%AB%98%E5%9C%A7+1%2F4&options%5Bprefix%5D=last",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/high-1.jpg?&width=100" alt="高圧洗浄機用ホース の画像">',
        text: "通常タイプの1/4サイズです。<br>3種類から長さを選べます。",
      },
    ],
  },
  {
    hx: "EVA泥除け",
    text: "トラックに使用するEVA素材の泥除けゴムです。<br>カラーは5色のバリエーションがあります。",
    variations: [
      {
        hx: "カラー：赤",
        url: "https://www.slingbelt.com/search?q=%E6%B3%A5%E9%99%A4%E3%81%91+%E8%B5%A4&options%5Bprefix%5D=last",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/eva-01.png?&width=100" alt="EVA泥除け  の画像">',
        text: "赤色の10枚セットです。<br>2tor3tトラック用あります。",
      },
      {
        hx: "カラー：白",
        url: "https://www.slingbelt.com/search?q=%E6%B3%A5%E9%99%A4%E3%81%91+%E7%99%BD&options%5Bprefix%5D=last",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/eva-01.png?&width=100" alt="EVA泥除け  の画像">',
        text: "白色の10枚セットです。<br>2tor3tトラック用あります。",
      },
      {
        hx: "カラー：黄",
        url: "https://www.slingbelt.com/search?q=%E6%B3%A5%E9%99%A4%E3%81%91+%E9%BB%84&options%5Bprefix%5D=last",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/eva-01.png?&width=100" alt="EVA泥除け  の画像">',
        text: "黃色の10枚セットです。<br>2tor3tトラック用あります。",
      },
      {
        hx: "カラー：青",
        url: "https://www.slingbelt.com/search?q=%E6%B3%A5%E9%99%A4%E3%81%91+%E9%9D%92&options%5Bprefix%5D=last",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/eva-01.png?&width=100" alt="EVA泥除け  の画像">',
        text: "青色の10枚セットです。<br>2tor3tトラック用あります。",
      },
      {
        hx: "カラー：黒",
        url: "https://www.slingbelt.com/search?q=%E6%B3%A5%E9%99%A4%E3%81%91+%E9%BB%92&options%5Bprefix%5D=last",
        img: '<img src="https://www.slingbelt.com/cdn/shop/files/eva-01.png?&width=100" alt="EVA泥除け  の画像">',
        text: "黒色の10枚セットです。<br>2tor3tトラック用あります。",
      },
    ],
  },
];

//お役立ちコンテンツデータ left =============================
var sb25_usageguides_left = [
  {
    hx: "プチカスタムでより快適に!",
    url: "https://www.slingbelt.com/pages/20221101puchicustom",
  },
  {
    hx: "スリングベルトを長く、安全にご使用いただくために",
    url: "https://www.slingbelt.com/pages/20220524mantenance",
  },
  {
    hx: "ラッシングベルトの点検基準",
    url: "https://www.slingbelt.com/pages/rasshing_standard",
  },
  {
    hx: "三価クロムとは？",
    url: "https://www.slingbelt.com/pages/20220308chromium",
  },
  {
    hx: "ベルトサンプル無料提供サービス",
    url: "https://www.slingbelt.com/pages/contact",
  },
  {
    hx: "引越しお役立ちカムバックルベルト",
    url: "https://www.slingbelt.com/pages/20220222moving",
  },
];
var sb25_usageguides_right = [
  {
    hx: "AVIELANの商品コードについて",
    url: "https://www.slingbelt.com/pages/20211207code",
  },
  {
    hx: "ダブルセーフティロックとは",
    url: "https://www.slingbelt.com/pages/20211019doublesaftylock",
  },
  {
    hx: "右固定？左固定？",
    url: "https://www.slingbelt.com/pages/20211005kotei_lr",
  },
  {
    hx: "固定側・巻取側ってナニ？",
    url: "https://www.slingbelt.com/pages/kotei_makitori",
  },
  {
    hx: "特注製作について",
    url: "https://www.slingbelt.com/pages/order2021",
  },
];

//アコーディオンメニューなどの汎用データ =============================
var sb25_linkAssets = {
  lashing: [
    {
      hx: "ブルー",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=blue",
    },
    {
      hx: "ブラック",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=black",
    },
    {
      hx: "ホワイト",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=white",
    },
    {
      hx: "反射レッド",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=red",
    },
    {
      hx: "イエロー(強化タイプ)",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=yellow",
    },
    {
      hx: "グレー",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=gray",
    },
    {
      hx: "OD(オリーブドラブ)",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=od",
    },
    {
      hx: "オレンジ",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=orange",
    },
    {
      hx: "積載車用",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.products._spec=loading_vehicles",
    },
    {
      hx: "オールステンレス",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.products._spec=stainless_steel",
    },
    {
      hx: "ブラック/グレー",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=black-gray",
    },
    {
      hx: "ブラック/ホワイト",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=black-white",
    },
    {
      hx: "OD/ブラック",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=od-black",
    },
    {
      hx: "ホワイト/オレンジ",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=white-orange",
    },
    {
      hx: "ブラック/イエロー(強化タイプ)",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._color=black-yellow",
    },
    {
      hx: "耐熱素材",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.products._spec=heat_resistant",
    },
  ],
  lashing_hook: [
    {
      hx: sb25_lashing_step2[0].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._type=r_hook",
      img: sb25_lashing_step2[0].img,
    },
    {
      hx: sb25_lashing_step2[1].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._type=j_hook",
      img: sb25_lashing_step2[1].img,
    },
    {
      hx: sb25_lashing_step2[2].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._type=j_hook_single",
      img: sb25_lashing_step2[2].img,
    },
    {
      hx: sb25_lashing_step2[3].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._type=i_hook",
      img: sb25_lashing_step2[3].img,
    },
    {
      hx: sb25_lashing_step2[4].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._type=rj_hook",
      img: sb25_lashing_step2[4].img,
    },
    {
      hx: sb25_lashing_step2[5].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._type=ij_hook",
      img: sb25_lashing_step2[5].img,
    },
    {
      hx: sb25_lashing_step2[6].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._type=snap_hook",
      img: sb25_lashing_step2[6].img,
    },
    {
      hx: sb25_lashing_step2[7].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._type=snap_hook_twist",
      img: sb25_lashing_step2[7].img,
    },
    {
      hx: sb25_lashing_step2[8].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._type=flat_hook",
      img: sb25_lashing_step2[8].img,
    },
    {
      hx: sb25_lashing_step2[9].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._type=d_ring",
      img: sb25_lashing_step2[9].img,
    },
    {
      hx: sb25_lashing_step2[10].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.belt._type=endless",
      img: sb25_lashing_step2[10].img,
    },
    {
      hx: sb25_lashing_step2[11].hx,
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.products._spec=loading_vehicles",
      img: sb25_lashing_step2[11].img,
    },
    {
      hx: "オールステンレス",
      url: "https://www.slingbelt.com/collections/lashingbelt?filter.p.m.products._spec=stainless_steel",
      img: '<img src="https://cdn.shopify.com/s/files/1/0610/1994/7144/files/img_sus.png" alt="オールステンレス の画像">',
    },
  ],
  sling: [
    {
      hx: "25mm幅",
      url: "https://www.slingbelt.com/products/slg25",
      img: sb25_sling_step1[0].image,
    },
    {
      hx: "50mm幅",
      url: "https://www.slingbelt.com/products/slg50",
      img: sb25_sling_step1[1].image,
    },
    {
      hx: "75mm幅",
      url: "https://www.slingbelt.com/products/slg75",
      img: sb25_sling_step1[2].image,
    },
    {
      hx: "100mm幅",
      url: "https://www.slingbelt.com/products/slg100",
      img: sb25_sling_step1[3].image,
    },
    {
      hx: "150mm幅",
      url: "https://www.slingbelt.com/products/slg150",
      img: sb25_sling_step1[4].image,
    },
    {
      hx: "200mm幅",
      url: "https://www.slingbelt.com/products/slg200",
      img: sb25_sling_step1[5].image,
    },
    {
      hx: "300mm幅",
      url: "https://www.slingbelt.com/products/slg300",
      img: sb25_sling_step1[6].image,
    },
  ],
  round: [
    {
      hx: "1t用",
      url: "https://www.slingbelt.com/products/rds1",
      img: sb25_round_step1[0].image,
    },
    {
      hx: "2t用",
      url: "https://www.slingbelt.com/products/rds2",
      img: sb25_round_step1[1].image,
    },
    {
      hx: "3t用",
      url: "https://www.slingbelt.com/products/rds3",
      img: sb25_round_step1[2].image,
    },
    {
      hx: "4t用",
      url: "https://www.slingbelt.com/products/rds4",
      img: sb25_round_step1[3].image,
    },
    {
      hx: "5t用",
      url: "https://www.slingbelt.com/products/rds5",
      img: sb25_round_step1[4].image,
    },
    {
      hx: "6t用",
      url: "https://www.slingbelt.com/products/rds6",
      img: sb25_round_step1[5].image,
    },
    {
      hx: "8t用",
      url: "https://www.slingbelt.com/products/rds8",
      img: sb25_round_step1[6].image,
    },
    {
      hx: "10t用",
      url: "https://www.slingbelt.com/products/rds10",
      img: sb25_round_step1[7].image,
    },
    {
      hx: "15t用",
      url: "https://www.slingbelt.com/products/rds15",
      img: sb25_round_step1[8].image,
    },
    {
      hx: "20t用",
      url: "https://www.slingbelt.com/products/rds20",
      img: sb25_round_step1[9].image,
    },
    {
      hx: "8t用(軽量型)",
      url: "https://www.slingbelt.com/products/rds8-pe",
      img: sb25_round_step1[10].image,
    },
    {
      hx: "10t用(軽量型)",
      url: "https://www.slingbelt.com/products/rds10-pe",
      img: sb25_round_step1[11].image,
    },
    {
      hx: "15t用(軽量型)",
      url: "https://www.slingbelt.com/products/rds15-pe",
      img: sb25_round_step1[12].image,
    },
    {
      hx: "20t用(軽量型)",
      url: "https://www.slingbelt.com/products/rds20-pe",
      img: sb25_round_step1[13].image,
    },
  ],
};

//ページが読み込まれた最後に実行する
//キャッシュ生成用の処理
window.addEventListener("load", function () {
  $.each(sb25_lashing_step3, function (index, val) {
    // console.log(val);

    $.each(val.img_url, function (index2, img_url) {
      if (img_url == "") {
        return true;
      }

      $(".js_imgCacheArea").append(
        '<img src="' + img_url + '" decoding="async" style="display:none">'
      );
    });
  });
});

//データをもとにDOMの生成をする関数
function sb25_generateItems(options) {
  const {
    containerSelector,
    dataArray,
    templateSelector,
    outputWrapperSelector,
    onInsert,
    toggleSelector, // トグル用セレクタ（省略OK）
  } = options;

  const processobj = $(containerSelector);

  // トグル処理（指定があれば実行）
  if (toggleSelector) {
    processobj.on("click", toggleSelector, function () {
      $(this).toggleClass("cl_open");
    });
  }

  // 雛形クローン
  const cloneobj = processobj.find(templateSelector).first().clone(true);

  // 出力先を空にする
  const outputWrapper = processobj.find(outputWrapperSelector);
  outputWrapper.empty();

  // データ数分ループ
  $.each(dataArray, function (index, val) {
    const newElm = cloneobj.clone();
    outputWrapper.append(newElm);

    const insobj = outputWrapper.find(templateSelector).last();

    // 個別カスタム処理
    if (typeof onInsert === "function") {
      onInsert(insobj, val, index);
    }
  });
}